<p>promise-request works!</p>
